<template>
  <div class="login">
  <form id="login" @submit.prevent="onLogin()" method="post">
    <p class="mb10">{{ $t('id_email_address') }}</p>
    <input
      type="text"
      placeholder=""
      class="mb10"
      v-model="login.email"
      :class="[$v.login.email.$error ? 'input-error' : '']"
    >
    <div v-if="submitted && $v.login.email.$error">
      <p class="error-txt mb20" v-if="!$v.login.email.required">{{ $t('please_enter_your_ID_email_address') }}</p>
      <p class="error-txt mb20" v-else>{{ $t('the_format_of_the_email_address_is_different') }}</p>
    </div>

    <p class="mb10">{{ $t('password') }}</p>
    <input
      type="password"
      placeholder=""
      class="mb10"
      v-model="login.password"
      :class="[$v.login.password.$error ? 'pwd-error' : '']"
    >
    <div v-if="submitted && $v.login.password.$error">
      <p class="error-txt mb20" v-if="!$v.login.password.required">{{ $t('please_enter_your_password') }}</p>
    </div>

    <!-- <div class="login-checkbox-area mb40">
      <label>
        <input type="checkbox" name="remember" class="checkbox-input" v-model="rememberMe">
        <span class="checkbox-parts">{{ $t('keep_logged_in') }}</span>
      </label>
    </div> -->
    <div class="mb10">
      <p class="error-txt mb10" v-if="submitted && errorLogin && !$v.login.password.$error">{{ errorLogin }}</p>
    </div>
    <button class="btn-base mb20" type="submit" style="border: #ffa300"><a><p>{{ $t('login') }}</p></a></button>
    <p class="center">
      <router-link :to="'send-reset-link'">{{ $t('forgot_password') }}</router-link>
    </p>
  </form>
  <Spinner :isLoading="isLoading"/>
  </div>
</template>

<script>
  import { required, email } from "vuelidate/lib/validators"
  import { Strings } from "@/js/commons/strings"
  import { mapState } from 'vuex'
  import { isLogin, setLogRocket } from "@/js/commons/commons"
  import Spinner from '@/js/components/Spinner'
  import DeviceInfo from "@/js/commons/CheckDeviceLoginHelper"
  window.Vue = require('vue')

  export default {
    components: {
      Spinner,
    },
    data() {
      return {
        isLoading: false,
        Strings: Strings,
        login: {
          email: '',
          password: ''
        },
        rememberMe: true,
        submitted: false,
        DeviceInfo
      }
    },
    validations: {
      login: {
        email: { required, email },
        password: { required },
      }
    },
    mounted() {
      this.screenTracking(this.$t('login'))
    },
    async created() {
      if(isLogin()) {
        this.$router.push('/').catch(()=>{})
      }
      if (this.$route.query.email) {
        this.login.email = this.$route.query.email
      }
    },
    computed: {
      ...mapState({
        needReset: state => state.auth.needReset,
        errorLogin: state => state.auth.errorLogin,
        session: state => state.auth.session,
      })
    },
    methods: {
      async onLogin() {
        this.submitted = true
        window.localStorage.setItem('isLogout', false)
        let params = {
          email: this.login.email,
          password: this.login.password,
          device_token: this.$store.state.auth.fcmToken
        }
        this.$v.login.$touch()
        if (this.$v.login.$error) return
        else {
          setLogRocket(this.login.email)
          this.isLoading = true
          await this.$store.dispatch('auth/login', params)
          if (!this.errorLogin) {
            if (this.needReset) {
              this.$store.dispatch('auth/setResetInfo', {
                email: this.login.email,
                password: this.login.password
              })
              this.$router.push('/first-time-reset')
            } else if (this.session) {
              this.$store.dispatch('auth/setRememberMe', this.rememberMe)
              this.$router.push('/verify')
            } else {
              this.$store.dispatch('auth/setRememberMe', this.rememberMe)
              await this.$store.dispatch('auth/getDoctorInfo')
              .then(res => {
                if(this.$route.query.hasOwnProperty("continue")) {
                  this.$router.push(decodeURIComponent(this.$route.query.continue)).catch(()=>{})
                }
                else {
                  this.$router.push('/').catch(()=>{})
                }
              })
              await this.$store.dispatch(
                "auth/checkLoginDevice",
                this.DeviceInfo.getDeviceInfo()
              )
            }
          }
          this.isLoading = false
        }
      }
    }
  }
</script>